import { getFilterMetadata } from '../../../../components/StatelessComponent/FilterChainUtils';
import { readableRadioDateOperations } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioDateFilter/GenericRadioDateDropdown';
import type { RadioDateFilterValueType } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioDateFilter/GenericRadioDateType';
import { RadioDateFilterOperationsWithoutSpecificValue } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioDateFilter/GenericRadioDateType';
import type { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../../LabelFormatterType';

export const getValueLabel = (value: RadioDateFilterValueType): string => {
  if (!value) {
    return '';
  }
  if (
    'value' in value &&
    !RadioDateFilterOperationsWithoutSpecificValue.includes(value.operation)
  ) {
    if (value.value instanceof Date) {
      const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
      const formatedDate = dateTimeFormat.format(value.value);
      return `${readableRadioDateOperations[value.operation]} "${formatedDate}"`;
    }
    return `${readableRadioDateOperations[value.operation]} "${value.value}" days ago`;
  }
  return readableRadioDateOperations[value.operation];
};

export function getLabels(
  currentValue: RadioDateFilterValueType | undefined,
  filterKind: FilterKindEnum,
): LabelProps {
  const metadata = getFilterMetadata(filterKind);
  return {
    label1: metadata.filterName,
    label2: getValueLabel(currentValue),
  };
}
